import React from 'react';
import classNames from 'classnames/bind';
import { ResponsiveCarousel } from '@components';
import { Typography } from 'gd-design-library';
import { ImageTransformation, ProductDetailsSliderItem } from '@services';
import { ALL_IMAGES_TRANSFORMATIONS } from '@utils';
import styles from '../ProductStaticContent.module.scss';

const CN = 'product-static-content';
const productDetailsItemClassName = `${CN}__product-details-item`;
const productDetailsItemTitleClassName = `${productDetailsItemClassName}__title`;
const cx = classNames.bind(styles);

interface Props {
  productDetailsItem: ProductDetailsSliderItem;
}

export const Slider: React.FC<Props> = ({
  productDetailsItem: {
    slider: {
      title,
      images
    }
  }
}) => {
  const imageTransformation = new ImageTransformation();

  return (
    <div className={ cx(productDetailsItemClassName) }>
      <Typography className={ cx(productDetailsItemTitleClassName) } variant='h4' >
        {title}
      </Typography>
      <ResponsiveCarousel
        showThumbs={ false }
        showArrows={ true }
        showStatus={ false }
        showIndicators={ true }
      >
        {images.map(image => (
          <img
            key={ image.public_id }
            src={ imageTransformation.transformById(
              image.public_id,
              ALL_IMAGES_TRANSFORMATIONS
            ) }
          />
        ))}
      </ResponsiveCarousel>
    </div>
  );
};
